import { LanguageCode } from 'i18n/internationalization.types';

export const LANGUAGES: readonly LanguageCode[] = [
  LanguageCode.EN,
  LanguageCode.IT,
  LanguageCode.FR,
  LanguageCode.KO,
  LanguageCode.ES,
  LanguageCode.TR,
  LanguageCode.PT,
  LanguageCode.VI,
  LanguageCode.DE,
  LanguageCode.ZH,
  LanguageCode.PL,
  LanguageCode.JA,
  LanguageCode.NL,
  LanguageCode.AR,
] as const;
